<template>
    <tq-loader-container :p_show-loader_b="co_showMainLoader_b" class="TQ_center TQ_margin_bottom_32px" :p_tq-loader_b="true">
        <div v-if="!co_showMainLoader_b">

            <!-- title -->
            <div class="TQ_padding_8px TQ_text_capitalize TQ_bg_white TQ_margin_bottom_8px TQ_box_shadow TQ_bg_purple_dark TQ_grid_col_1frAuto">

                <div class="TQ_grid_verticalCenter TQ_align_initial TQ_text_24px">
                    {{ ass_strings.threeWords_createNewQuest[store_systemLangCode_ve.val]}}
                    <div class="TQ_direction_ltr TQ_inline"> ({{server_ownerQuestPermissions_ac.length}}/{{co_totalAvailableQuestNum_n}}) </div>
                </div>

                <tq-more-info :p_more-info-id_uid="enum_moreInfo_helpersIds_s.helpers_createQuest"
                              :p_img_e="enum_moreInfoImgOptions_e.ass_img_info2_w"
                              class="TQ_width_32px TQ_grid_verticalCenter"/>

            </div>

            <!-- error - cant create new quest-->
            <div v-if="co_totalAvailableQuestNum_n <= server_ownerQuestPermissions_ac.length" class="TQ_padding_32px TQ_bg_white TQ_text_24px TQ_text_capitalize">
                <div class="TQ_inline TQ_verticalAlignMiddle TQ_text_selectable">
                    {{ass_strings.sentence_questsQuotaLimit[store_systemLangCode_ve.val]}}
                    <span class="TQ_text_bold TQ_text_underline"> {{co_totalAvailableQuestNum_n}}</span> {{ass_strings.oneWord_quests[store_systemLangCode_ve.val] }}
                </div>
                <div class="TQ_padding_8px "></div>

            </div>

            <!-- body -->
            <div v-else class="TQ_grid_col_auto1fr TQ_grid_gap_8px ">

                <!-- navigation -->
                <div class="TQ_align_initial TQ_bg_white TQ_text_capitalize">
                    <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_20px ">
                        {{ ass_strings.oneWord_steps[store_systemLangCode_ve.val] }}
                    </div>

                    <div v-for="(steps_o, stepsIndex_n) in steps_ao"
                         @click="m_clickStepMenu_f(stepsIndex_n)"
                         class="TQ_padding_8px TQ_grid_col_auto1fr TQ_grid_gap_8px TQ_text_20px"
                         :class="[stepsIndex_n ===currentStepIndex_n && 'TQ_bg_gold', stepsIndex_n > lastMostAdvanceStep_n ? 'TQ_textColor_gray2' : 'TQ_clickable TQ_bg_hover_goldLite']">

                        <div class="TQ_grid_verticalCenter">{{stepsIndex_n+1}}) </div>
                        <!--<tq-image :pb_src_r="steps_o.img_s" class="TQ_width_24px TQ_grid_verticalCenter"/>-->
                        <div class="TQ_grid_verticalCenter">
                            {{steps_o.name_blc_s[store_systemLangCode_ve.val]}}
                        </div>
                    </div>
                </div>

                <!-- body -->
                <div class="TQ_bg_white">

                    <!-- title -->
                    <div class="TQ_align_initial TQ_padding_8px TQ_text_24px TQ_border_bottom TQ_text_capitalize">
                        {{ steps_ao[currentStepIndex_n].name_blc_s[store_systemLangCode_ve.val]}}
                    </div>

                    <!-- 0) quest mold -->
                    <div v-if="currentStepIndex_n ===0" class="TQ_padding_8px">
                        <div v-for="questMold_c in server_questMolds_byQuestId_c"
                             @click="m_selectQuestMold_f(questMold_c)"
                             :class="[selectedQuestMold_c && questMold_c.qm_questId_uid === selectedQuestMold_c.qm_questId_uid && 'TQ_border_g_2px']"
                             class="TQ_clickable TQ_bg_hover_goldLite TQ_inline TQ_padding_8px TQ_bg_white TQ_borderRadius TQ_box_shadow2 TQ_width_100p TQ_maxWidth_400px TQ_margin_8px TQ_borderBox">

                            <!-- top image -->
                            <tq-on-top-container>
                                <tq-img-fill-blur slot="body"
                                                  p_height_s="300px"
                                                  :pp_img-url_s="questMold_c.so_slides_blc_ac[questMold_c.ml_m_displayLang_fe(store_systemLangCode_ve.val)][0].sd_imageUrl_s"/>

                                <tq-image slot="topLeft" :pb_src_r="ass_img_info3_w"
                                          @click.native.stop="m_questMold_showMoreInfo_f(questMold_c)"
                                          class="TQ_bg_purple TQ_width_36px TQ_box_shadow TQ_bg_circle TQ_padding_2px TQ_Animation_smallBigSmall_infinite_hover TQ_clickable" />

                            </tq-on-top-container>

                            <!-- text -->
                            <div class="TQ_align_initial TQ_margin_8px_0">
                                <div class="TQ_text_bold TQ_text_20px">
                                    {{ questMold_c.so_slides_blc_ac[questMold_c.ml_m_displayLang_fe(store_systemLangCode_ve.val)][0].sd_title_s }}
                                </div>
                                <div>
                                    {{ questMold_c.so_slides_blc_ac[questMold_c.ml_m_displayLang_fe(store_systemLangCode_ve.val)][0].sd_description_s }}
                                </div>

                                <div class="TQ_margin_top_8px">
                                    [
                                    <div class="TQ_inline " v-for="(langCode_e, index_n) in questMold_c.ml_langArr_ae">
                                        <span v-if="index_n>0">, </span>
                                        {{format_langCode_fs(langCode_e)}}
                                    </div>
                                    ]
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- 1) intro info -->
                    <c_-creator_-edit-quests_-item_-explore-basic
                        v-else-if="currentStepIndex_n === 1 && selectedQuestExplore_c"
                        :p_store_system-lang-code_e="store_systemLangCode_ve.val"
                        :p_creator-data_c="server_creatorData_c"
                        :p_quest-body_c="selectedQuestBody_c"
                        :p_quest-explore_c="selectedQuestExplore_c"/>

                    <!-- 2) quest gallery -->
                    <c_-creator_-edit-quests_-item_-explore-gallery v-else-if="currentStepIndex_n === 2"
                                                                    :store_system-lang-code="store_systemLangCode_ve.val"
                                                                    :pe_choose-file_f="(cb_f) => {m_showQuestFiles_f(cb_f, true, false, false)}"
                                                                    :quest-explore="selectedQuestExplore_c"/>

                    <!-- 3) Description -->
                    <c_-creator_-edit-quests_-item_-explore_-info
                        v-else-if="currentStepIndex_n === 3"
                        pb_uid_s="Intro"
                        :ps_lang-code_e="store_systemLangCode_ve.val"
                        :pb_quest-explore_c="selectedQuestExplore_c"
                    />

                    <!-- 4) intro video -->
                    <c_-creator_-edit-quests_-item_intro-video v-else-if="currentStepIndex_n === 4"
                                                               class="TQ_padding_16px"
                                                               :pe_choose-file_f="(cb_f) => {m_showQuestFiles_f(cb_f, false, true, false)}"
                                                               :p_quest-explore_c="selectedQuestExplore_c"/>

                    <!-- 5) pricing -->
                    <c_-creator_-edit-quests_-item_-explore-tickets
                        v-else-if="currentStepIndex_n === 5"
                        :p_qex_lang-arr_ae="selectedQuestExplore_c.qex_langArr_ae"
                        :p_qex_available-tickets_ac="selectedQuestExplore_c.qex_availableTickets_ac"
                        :p_system_lang-code_e="store_systemLangCode_ve.val"
                        :p_system_currency_e="selectedQuestExplore_c.val"
                        :p_qex_metadata_c="selectedQuestExplore_c.qex_metadata_c"
                    />

                    <!-- 6) btns -->
                    <div>
                        <div class="TQ_text_20px TQ_margin_8px TQ_grid_col_Auto1frAuto" >

                            <div>
                                <div @click="currentStepIndex_n--"
                                     v-if="currentStepIndex_n > 0"
                                     class="TQ_padding_8px TQ_bg_gray1 TQ_borderRadius TQ_box_shadow2 TQ_clickable TQ_inline TQ_width_72px TQ_center TQ_textColor_white">
                                    {{ ass_strings.oneWord_prev[store_systemLangCode_ve.val] }}
                                </div>
                            </div>

                            <div class="TQ_padding_4px TQ_inline"> </div>

                            <tq-loader-button v-if="currentStepIndex_n < this.steps_ao.length - 1 && m_availableStep_b(currentStepIndex_n)"
                                              class="TQ_padding_8px TQ_margin_8px TQ_bg_purple TQ_borderRadius TQ_box_shadow2 TQ_clickable TQ_inline TQ_width_72px TQ_center"
                                              @click.native="!showBtnLoader_b && m_click_nextBtn()"
                                              p_loader-color_s="white"
                                              :show-loader="showBtnLoader_b" >
                                <div>
                                    {{ ass_strings.oneWord_next[store_systemLangCode_ve.val] }}
                                </div>
                            </tq-loader-button>

                            <tq-btn-approve :popup-text="ass_strings.question_updateQuest"
                                            :system-lang-code="store_systemLangCode_ve.val"
                                            v-else-if="currentStepIndex_n === this.steps_ao.length - 1"
                                            class="TQ_padding_8px TQ_margin_8px TQ_bg_purple TQ_borderRadius TQ_box_shadow2 TQ_clickable TQ_inline TQ_width_72px TQ_center"
                                            :approve-cb="m_click_createBtn">
                                {{ ass_strings.oneWord_create[store_systemLangCode_ve.val] }}
                            </tq-btn-approve>

                        </div>
                    </div>

                </div>

            </div>

            <!-- popup - quest Mold more info -->
            <tq-popup :show="showPopup_moldInfo_vb" v-if="showPopup_moldInfo_vb.val" max-width="400px">

                <fcc-display-slides-data
                    v-if="selectedQuestMold_moreInfo_c"
                    :pe_click-finish_f="() => {showPopup_moldInfo_vb.val = false}"
                    p_slide-height_s="300px"
                    :p_slides-data_ac="selectedQuestMold_moreInfo_c.so_slides_blc_ac[selectedQuestMold_moreInfo_c.ml_m_displayLang_fe(store_systemLangCode_ve.val)]"/>

            </tq-popup>

            <!-- Choose file -->
            <tq-popup :show="popup_chooseFile_show_vb" width="100%" p_height_s="100vh" class="TQ_center" padding="0" :show-close-btn="true">
                <fcuc-drive
                    :p_can-choose-image_b="popup_chooseFile_chooseImage_b"
                    :p_can-choose-video_b="popup_chooseFile_chooseVideo_b"
                    :p_can-choose-audio_b="popup_chooseFile_chooseAudio_b"
                    :pe_choose-file_f="m_chooseFile_f"
                />
            </tq-popup>

        </div>
    </tq-loader-container>
</template>

<script>

    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
    import {
        server_questMold_getAll_f,
        serverPre_subUserData_moreInfo_get_f,
        serverPre_subUserData_subscriptionPlanInfo_get_f,
        serverPre_userDataSub_questPermission_get_withUserId_f
    } from "@/scripts/Server/S_ServerPre";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
    import TqImagesSlider from "@/components/basic/TqImagesSlider";
    import {FB_File, FB_QuestPointer} from "../../../../functions/src/shareCode/Share_S_Classes";
    import {format_langCode_fs} from "../../../../functions/src/shareCode/Share_S_Format";
    import {store_getStateValue_vo, store_var} from "@/store";
    import {
        server_duplicateQuest_f,
        serverBig_questExplore_once_f,
        serverBig_questBody_once_fp
    } from "@/scripts/Server/S_ServerFirestore";
    import {
        enum_availableTicketsTypes_s,
        enum_moreInfo_featuresIds_s,
        enum_featuresMinPoints,
        enum_moreInfo_helpersIds_s, enum_moveToOptions, enum_questPermission_n, enum_moreInfoImgOptions_e
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f, serverAuth_getOtherUserData_f
    } from "@/scripts/Server/S_ServerAuth";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqPopup from "@/components/basic/TqPopup";
    import TqDisplaySlidesData from "@/components/complex/TqDisplaySlidesData";
    import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
    import C_Creator_EditQuests_Item_ExploreBasic
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_ExploreBasic";
    import TqImage from "@/components/basic/TqImage";
    import {
        ass_img_document_b, ass_img_edit2_b,
        ass_img_gallery_b,
        ass_img_info2_b,
        ass_img_info3_b,
        ass_img_info3_w,
        ass_img_info_b, ass_img_tickets_b, ass_img_video_b
    } from "@/assets/scripts/Ass_Files";
    import C_Creator_EditQuests_Item_ExploreGallery
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_ExploreGallery";
    import C_Creator_EditQuests_Item_introVideo
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_introVideo";
    import C_Creator_EditQuests_Item_Explore_Info
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/C_Creator_EditQuests_Item_Explore_Info";
    import TqLoaderButton from "@/components/basic2/TqLoaderButton";
    import C_Creator_EditQuests_Item_ExploreTickets
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_ExploreTickets";
    import FcucDrive from "@/components/unpure/FcucDrive";
    import {route_moveToRoute_withData_f} from "@/router";
    import TqBtnApprove from "@/components/basic2/TqBtnApprove";
    import TqMoreInfo from "@/components/basic2/TqMoreInfo";
    import FccDisplaySlidesData from "@/components/complex/TqDisplaySlidesData";
    import {helper_features_totalAvailableQuests_n} from "@/scripts/S_Helper";
    export default {
        name: "v_Creator_EditQuests_create",
        components: {
            FccDisplaySlidesData,
            TqMoreInfo,
            TqBtnApprove,
            FcucDrive,
            C_Creator_EditQuests_Item_ExploreTickets,
            TqLoaderButton,
            C_Creator_EditQuests_Item_Explore_Info,
            C_Creator_EditQuests_Item_introVideo,
            C_Creator_EditQuests_Item_ExploreGallery,
            TqImage,
            C_Creator_EditQuests_Item_ExploreBasic,
            TqOnTopContainer,
            TqDisplaySlidesData,
            TqPopup,
            TqImagesSlider,
            TqImgFillBlur,
            TqLoaderContainer
        },
        data(){
            return {

                steps_ao : [
                    {name_blc_s : ass_strings.twoWords_questTemplate,       moreInfoId_uid: enum_moreInfo_helpersIds_s.helpers_edit_intro_basicInfo, img_s: ass_img_gallery_b},
                    {name_blc_s : ass_strings.twoWords_basicInfo,       moreInfoId_uid: enum_moreInfo_helpersIds_s.helpers_edit_intro_basicInfo, img_s: ass_img_edit2_b},
                    {name_blc_s : ass_strings.twoWords_photosGallery,   moreInfoId_uid: enum_moreInfo_helpersIds_s.helpers_edit_intro_basicInfo, img_s: ass_img_gallery_b},
                    {name_blc_s : ass_strings.oneWord_description,      moreInfoId_uid: enum_moreInfo_helpersIds_s.helpers_edit_intro_basicInfo, img_s: ass_img_document_b},
                    {name_blc_s : ass_strings.oneWord_video,            moreInfoId_uid: enum_moreInfo_helpersIds_s.helpers_edit_intro_basicInfo, img_s: ass_img_video_b},
                    {name_blc_s : ass_strings.oneWord_pricing,          moreInfoId_uid: enum_moreInfo_helpersIds_s.helpers_edit_intro_basicInfo, img_s: ass_img_tickets_b},
                ],

                popup_chooseFile_show_vb        : {val : undefined},
                popup_chooseFile_chooseImage_b  : true,
                popup_chooseFile_chooseVideo_b  : true,
                popup_chooseFile_chooseAudio_b  : true,
                popup_chooseFile_cb_f           : null,

                selectedQuestMold_moreInfo_c : null,
                showPopup_moldInfo_vb : {val : false},

                selectedQuestMold_c : null,
                selectedQuestExplore_c : null,
                selectedQuestBody_c : null,

                currentStepIndex_n : 0,
                lastMostAdvanceStep_n : 0,

                showBtnLoader_b : false,
                loader_createQuest_b : false,

                // store
                store_systemLangCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // server
                server_questMolds_byQuestId_c : undefined,
                server_currentUserData_c : undefined,
                server_uds_moreInfo_c : undefined,
                server_ownerQuestPermissions_ac : undefined,
                server_creatorData_c : undefined,
                server_uds_subscriptionPlanInfo_c : undefined,

                // imports
                ass_strings : ass_strings,
                ass_img_info3_w : ass_img_info3_w,
                FB_File : FB_File,
                enum_moreInfoImgOptions_e : enum_moreInfoImgOptions_e,
                enum_featuresIds_s : enum_moreInfo_featuresIds_s,
                enum_featuresMinPoints : enum_featuresMinPoints,
                enum_moreInfo_helpersIds_s : enum_moreInfo_helpersIds_s,
                enum_availableTicketsTypes_s : enum_availableTicketsTypes_s,
                format_langCode_fs: format_langCode_fs,

            }
        },
        computed:{
            co_showMainLoader_b(){
                return this.loader_createQuest_b || this.server_questMolds_byQuestId_c === undefined || this.server_currentUserData_c === undefined || this.server_ownerQuestPermissions_ac === undefined
            },
            co_totalAvailableQuestNum_n(){
                return this.server_uds_subscriptionPlanInfo_c ? this.server_uds_subscriptionPlanInfo_c.udsspi_maxQuests_n : 0
            },
        },
        methods:{
            m_questMold_showMoreInfo_f(questMold_c){
                this.selectedQuestMold_moreInfo_c = questMold_c
                this.showPopup_moldInfo_vb.val= true

            },
            m_clickStepMenu_f(stepIndex_n){
                if(stepIndex_n <= this.lastMostAdvanceStep_n){
                    this.currentStepIndex_n = stepIndex_n
                }
            },
            m_availableStep_b(stepIndex_n){
                switch(stepIndex_n){
                    case 0:
                        return this.selectedQuestMold_c != null
                    default:
                        return true
                }
            },

            m_selectQuestMold_f(questMold_c){

                 if(this.showBtnLoader_b){
                    return null
                }else if(this.selectedQuestMold_c && this.selectedQuestMold_c.qm_questId_uid === questMold_c.qm_questId_uid){
                    this.m_click_nextBtn()
                }else{
                    this.selectedQuestMold_c = questMold_c
                }

            },

            m_chooseFile_f(file_c){
                this.popup_chooseFile_show_vb.val = false
                this.popup_chooseFile_cb_f(file_c)
            },
            m_showQuestFiles_f(cb_f, chooseImage_b=true, chooseVideo_b=true, chooseAudio_b=true){
                this.popup_chooseFile_show_vb.val = true
                this.popup_chooseFile_chooseImage_b = chooseImage_b
                this.popup_chooseFile_chooseVideo_b = chooseVideo_b
                this.popup_chooseFile_chooseAudio_b = chooseAudio_b
                this.popup_chooseFile_cb_f = cb_f
            },

            m_click_nextBtn(){

                // choose quest mold
                if(this.currentStepIndex_n === 0 &&
                    (!this.selectedQuestExplore_c || this.selectedQuestMold_c.qm_questId_uid !== this.selectedQuestExplore_c.qex_questId_uid)){

                    this.lastMostAdvanceStep_n = 0
                    this.showBtnLoader_b = true
                    serverBig_questExplore_once_f(this.selectedQuestMold_c.qm_questId_uid, false, (questExplore_c) => {
                        this.selectedQuestExplore_c = questExplore_c
                        this.selectedQuestExplore_c.qex_creatorId_uid = this.server_currentUserData_c.ud_userId_uid

                        serverAuth_getOtherUserData_f(this.selectedQuestExplore_c.qex_creatorId_uid, (creatorData_c) => {
                            this.server_creatorData_c = creatorData_c

                            serverBig_questBody_once_fp(questExplore_c.qex_questType_e, questExplore_c.qex_questId_uid, false, false,(questBody_c) => {
                                this.selectedQuestBody_c = questBody_c


                                this.showBtnLoader_b = false
                                this.currentStepIndex_n = 1
                                this.lastMostAdvanceStep_n = 1

                            })
                        })


                    })
                }else{
                    this.currentStepIndex_n++
                    if(this.currentStepIndex_n > this.lastMostAdvanceStep_n){
                        this.lastMostAdvanceStep_n = this.currentStepIndex_n
                    }
                }


            },
            m_click_createBtn() {
                this.loader_createQuest_b = true
                server_duplicateQuest_f(this.selectedQuestExplore_c, this.selectedQuestBody_c, this.server_currentUserData_c.ud_userId_uid,(newQuestExplore_c) =>{
                    this.loader_createQuest_b = false

                    let createdQuest_c = new FB_QuestPointer({
                        qp_questId_uid : newQuestExplore_c.qex_questId_uid,
                        qp_questType_e : newQuestExplore_c.qex_questType_e
                    })

                    route_moveToRoute_withData_f(enum_moveToOptions.creator_edit_item, createdQuest_c)
                })
            },

        },

        // life circle
        activated(){
            // quests molds
            server_questMold_getAll_f( (questMolds_byQuestId_c)=>{
                this.server_questMolds_byQuestId_c = questMolds_byQuestId_c
            })

            // current user data
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c)=> {
                this.server_currentUserData_c = userData_c

                if(userData_c == null){
                    return
                }

                serverPre_subUserData_subscriptionPlanInfo_get_f({
                    userId_uid : userData_c.ud_userId_uid,
                    cb_f : (uds_subscriptionPlanInfo_c) => {
                        this.server_uds_subscriptionPlanInfo_c = uds_subscriptionPlanInfo_c
                    }
                })

                serverPre_userDataSub_questPermission_get_withUserId_f({
                    userId_uid : userData_c.ud_userId_uid,
                    questMinPermission_n : enum_questPermission_n.owner,
                    cb_f : (uds_questPermissions_ac) => {

                        this.server_ownerQuestPermissions_ac = uds_questPermissions_ac
                    }
                })

                serverPre_subUserData_moreInfo_get_f({
                    userId_uid : userData_c.ud_userId_uid,
                    cb_f : (uds_moreInfo_c) => {
                        this.server_uds_moreInfo_c = uds_moreInfo_c
                    }
                })


            })
        },
        deactivated(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        }

    };

</script>

<style scoped lang="scss">

    .lc_pricing_title{
        font-size: 28px;
        text-transform: capitalize;

        &.lc_titleYellow{
            color: var(--color-gold)
        }
    }

    .lc_bottomBtns{
        position: fixed;
        bottom: 0px;
        width: 100%;
    }

    input{
        padding: 8px;
    }

</style>